import { render, staticRenderFns } from "./ShiftItemAddButton.vue?vue&type=template&id=88919236&"
import script from "./ShiftItemAddButton.vue?vue&type=script&lang=js&"
export * from "./ShiftItemAddButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports